/* Will register additional offset to draw component */
//
//  Synchronize current's element css TOP property with main draw height.
//  This will give 'following' effect and will expand/collapse with draw.
//
//  Current element should have POSITION property set to fixed;
//
//  Value of this property can be set to 'parent' - this will update parent's css prop instead of elementRef.nativeElement.
//
import { Directive, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';

import { DrawCollapseService } from './draw-collapse.shared.service';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
    selector: '[directive-draw-follow]',
})
export class DrawFollowSharedDirective implements OnInit, OnDestroy {
    private _elem: HTMLElement;
    private _drawHeight$: Subscription;
    private _drawMobileHeight$: Subscription;

    constructor(
        private _drawCollapseService: DrawCollapseService,
        private _elementRef: ElementRef,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        const attr: string = this._elementRef.nativeElement.getAttribute('directive-draw-follow');
        this._elem = attr === 'parent' ? this._elementRef.nativeElement.parentElement : this._elementRef.nativeElement;

        this._renderer2.setStyle(this._elem, 'transition', `top ${this._drawCollapseService.transition}`);

        this._drawHeight$ = this._drawCollapseService.drawCurrentHeight$
            .pipe(
                filter(height => height !== null && height !== undefined && typeof height === 'number'),
            ).subscribe(this._setHeight.bind(this));

        this._drawMobileHeight$ = this._drawCollapseService.drawNavBarCollapseHeight$
            .pipe(
            ).subscribe(this._setHeight.bind(this));
    }

    ngOnDestroy(): void {
        if (this._drawHeight$ && !this._drawHeight$.closed) this._drawHeight$.unsubscribe();

        if (this._drawMobileHeight$ && !this._drawMobileHeight$.closed) this._drawHeight$.unsubscribe();
    }

    private _setHeight(height: number): void {
        this._renderer2.setStyle(this._elem, 'top', `${height}px`);
    }
}
